// @flow
import React from 'react';
import { navigate } from '@reach/router';
import { washingFrequencyApi } from './../../lib/api';
import CommonListPage from './../../components/hoc/common/handbook/ListPage';
import Page from '../../components/hoc/common/handbook/PageContext';
import { withUserAccess } from './../withUserAccess';

import { Filter } from './components';
import { getBreadCrumbsByUrl } from '../../lib/autoBreadcrumbs';

const entryPointPath = '/admin/washing-frequency/';

const columns = [
  {
    title: '№ записи',
    dataIndex: 'id'
  },
  {
    title: 'Тип ТС для мойки',
    dataIndex: 'vehicleType.type'
  }
];

const access = {
  add: () => navigate(`${entryPointPath}new`)
};

export default withUserAccess(({ userAccess }) => {
  const breadCrumbs = getBreadCrumbsByUrl(entryPointPath);

  return (
    <Page>
      <CommonListPage
        crud={washingFrequencyApi}
        pageHeaderProps={{
          breadCrumbs,
          mainHeader: 'Периодичность проведения моек ТС',
          access
        }}
        tableListProps={{
          columns,
          onSelect: (id: number) => navigate(`${entryPointPath}${id}`)
        }}
        filter={Filter}
      />
    </Page>
  );
});
